module.exports = __webpack_public_path__ + "static/media/koryu_00020.12fb5fde.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/koryu_00020.png
// module id = 232
// module chunks = 0